import React, {Component} from "react";
import { withApollo } from "react-apollo";
import { Switch, Route } from "react-router-dom";
import {
  ContentsList,
  ContentsNew,
  CategoriesList,
} from "pages";

class ApplicationContentManagement extends Component{

    render () {
        let { path } = this.props.match
        return (
      <div>
      <Switch>
          <Route
            exact
            path={`${path}/contents`}
            component={ContentsList}
          />
          <Route
            exact
            path={`${path}/categories`}
            component={CategoriesList}
          />
          <Route
            path={`${path}/contents/new`}
            component={ContentsNew}
          />
          <Route
            path={`${path}/contents/edit/:contentId`}
            component={ContentsNew}
          />
          </Switch>
      </div>    
        )
    }
  }
  export default withApollo(ApplicationContentManagement)


// WEBPACK FOOTER //
// ./src/components/ApplicationContentManagement.js